import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import queryClient from '../../../core/api/queryClient';
import { clearAuthToken } from '../../../core/commom/authToken';
import BrainLoadingWrapper from '../../../core/components/molecules/BrainLoading';
import { resetAll } from '../../../core/hooks/useResetStore';
import { useAccessControlStore } from '../../../core/stores/accessControlStore';
import { requestLogout } from '../queries/fetchAuth';
import { useUserStore } from '../stores/authStore';

const Logout = () => {
  const navigate = useNavigate();
  const [loggedOut, setLoggedOut] = useState(false);
  const redirectTo = useRef('');

  useEffect(() => {
    onLogout();
  }, []);

  const onLogout = async () => {
    const response = await logout();

    if (response) {
      setLoggedOut(true);
    }
  };

  useEffect(() => {
    if (loggedOut) {
      if (redirectTo.current) {
        navigate(redirectTo.current);
        return;
      }
      navigate('/login');
    }
  }, [loggedOut]);

  const logout = async () => {
    try {
      // Invalida sessão Redis no backend enquanto o token ainda está disponível
      await requestLogout();

      clearAuthToken();
      localStorage.removeItem('hasViewedDiagnosticPopup');

      const currentUser = useUserStore.getState().user;
      if (currentUser && currentUser.isB2B && currentUser.B2BCompany) {
        redirectTo.current = `/login/${currentUser.B2BCompany}`;
      }

      const setUser = useUserStore.getState().setUser;
      const setPermissions = useAccessControlStore.getState().setPermissions;

      resetAll();
      setPermissions([]);
      setUser(null, false, false);

      // O logout é navegação SPA: sem limpar o cache, o próximo login reaproveita
      // as queries da sessão anterior (inclusive o ['me'] com o token revogado).
      queryClient.clear();

      return true;
    } catch (error) {
      return false;
    }
  };

  return <BrainLoadingWrapper />;
};

export default Logout;
